.srOnly {
  position: absolute;
  inline-size: 1px;
  block-size: 1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}

.refusal {
  margin: 0;
  color: var(--danger-text);
  font-size: var(--font-size-13);
}

.hint {
  margin: 0;
  color: var(--text-subtle);
  font-size: var(--font-size-12);
}
